import { loadPoisByType } from '@/stores/load/loadPoisByType'
import { useLoad } from './useLoad'

export function useLoadPoisByType(
	type: string,
	{ level = 0, disable = false }: { level?: number; disable?: boolean } = {},
) {
	return useLoad(loadPoisByType, { level, type, disable })
}
